module.exports = __webpack_public_path__ + "assets/img/activity-time-4f8c9cc0.png";